import get from 'lodash/get';
import { Platform } from 'helpers/platform';
import { addNotificationHandler } from 'store/middleware/displayNotification';
import { isHomePageSelector } from '@lingoda/router';
import { studentSelector } from '@lingoda/students';
import { matchResolutionMedia } from '@lingoda/ui';
import { PurchaseType } from '@lingoda/graphql';
import { currentSubscriptionSelector, hasSubscriptionSelector } from '@lingoda/subscriptions';
import hasAccess from './_hasAccess';

void addNotificationHandler({
    check: (state) => {
        const student = studentSelector(state);
        const subscription = currentSubscriptionSelector(state);
        const hasSubscription = hasSubscriptionSelector(state);
        const isHomePage = isHomePageSelector(state);
        const isDesktop = matchResolutionMedia('desktop');

        if (
            student &&
            isHomePage &&
            hasSubscription &&
            isDesktop &&
            !get(student, 'preferences.notifications.startTourCourse') &&
            subscription &&
            subscription.purchaseType !== PurchaseType.LearningTeam &&
            hasAccess(student, 'newStudent', 1)
        ) {
            return { type: 'startTourCourse' };
        }
    },
    once: true,
    dependencies: ['subscriptions'],
    platforms: [Platform.SBE],
});
